/* eslint-disable import/no-deprecated */
import { intl } from '@fullstory/intl';
import { classNames } from '@fullstory/util/fmt';
import React, { ComponentProps } from 'react';
import { Toggle } from '../../components/Toggle';
import { Icon } from '../../deprecated/Icon';
import { identifyComponent } from '../../util';
import { Box } from '../Box';
import { Flex } from '../Flex';
import { RestrictedComponent } from '../RestrictedComponent';

interface RestrictedToggleProps
  extends ComponentProps<typeof Toggle>,
    ComponentProps<typeof RestrictedComponent> {
  label?: string;
  lockPosition?: 'left' | 'right';
}

const defaultTooltip = intl.formatMessage({
  defaultMessage: 'Your account does not have permission to modify this value.',
  id: 'LO7MjK',
});
export const RestrictedToggle: React.FC<RestrictedToggleProps> = ({
  label,
  lockPosition = 'right',
  tooltip = defaultTooltip,
  tooltipPlacement,
  tooltipAction,
  ...toggleProps
}) => {
  const lock = <Icon name="highlights/lock" size={16} color="neutrals-n7" />;
  const restrictedComponentProps: ComponentProps<typeof RestrictedComponent> = {
    tooltip,
    tooltipPlacement,
    tooltipAction,
    disabled: toggleProps.disabled,
  };
  return (
    <RestrictedComponent
      data-component="RestrictedToggle"
      {...restrictedComponentProps}
      {...identifyComponent('restricted-toggle')}
    >
      <Flex alignItems="center">
        {toggleProps.disabled && lockPosition === 'left' && <Box marginRight={4}>{lock}</Box>}
        <Toggle
          className={classNames(
            'fs-restricted-toggle',
            `fs-restricted-toggle-${toggleProps.checked ? 'checked' : 'unchecked'}`,
          )}
          label={label}
          {...toggleProps}
        />
        {toggleProps.disabled && lockPosition === 'right' && <Box marginLeft={4}>{lock}</Box>}
      </Flex>
    </RestrictedComponent>
  );
};
